export default __webpack_public_path__ + "static/media/euroc.d726848e.svg";